import { useEffect, useState } from "react";
import { AlertTriangle, Info, Zap, Sparkles, Tag, X } from "lucide-react";
import { fetchAnnouncements } from "@/lib/api";

const ICON = { info: Info, event: Sparkles, discount: Tag, maintenance: Zap, outage: AlertTriangle, emergency: AlertTriangle };
const COLOR = {
  info: "#FFBF00", event: "#FF8C00", discount: "#3ABEFF",
  maintenance: "#FF8C00", outage: "#FF3B3B", emergency: "#FF3B3B",
};

export default function AnnouncementBar() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("lostdc:ann:dismissed") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    fetchAnnouncements().then(setItems).catch(() => {});
  }, []);

  const visible = items.filter((a) => !dismissed.includes(a.id));
  if (!visible.length) return null;

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try { localStorage.setItem("lostdc:ann:dismissed", JSON.stringify(next)); } catch (err) { console.debug("ann dismiss persist failed", err?.message); }
  };

  return (
    <>
      <div className="fixed top-16 sm:top-20 inset-x-0 z-40 pointer-events-none" data-testid="announcement-bar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-2">
          {visible.slice(0, 2).map((a) => {
            const I = ICON[a.kind] || Info;
            const c = COLOR[a.kind] || "#FFBF00";
            return (
              <div
                key={a.id}
                className="pointer-events-auto flex items-center gap-3 px-4 py-2.5 rounded-full glass border shadow-lg"
                style={{ borderColor: `${c}55`, boxShadow: `0 8px 24px ${c}22` }}
                data-testid={`announcement-${a.id}`}
              >
                <I size={16} style={{ color: c }} />
                <div className="text-sm">
                  <span className="font-semibold" style={{ color: c }}>{a.title}</span>
                  {a.body && <span className="text-white/70 hidden md:inline"> · {a.body}</span>}
                </div>
                <button
                  data-testid={`announcement-dismiss-${a.id}`}
                  onClick={() => dismiss(a.id)}
                  className="ml-auto p-1 rounded-full hover:bg-white/10 text-white/50 hover:text-white"
                  aria-label="Dismiss"
                >
                  <X size={14} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
      {/* Spacer so page hero content isn't overlapped by fixed announcement bar */}
      <div aria-hidden="true" style={{ height: `${Math.min(visible.length, 2) * 52}px` }} />
    </>
  );
}
